import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import { Col, Container, Row } from "react-bootstrap";
import TopBar from "./TopBar";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import useAuth from "../../hooks/useAuth";

const GetFranchise = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/listfranchises");
  }
  const { franchiseId } = useParams(); // Get the franchiseId from the URL
  const [franchise, setFranchise] = useState(null);  // To store fetched franchise data
  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null);    // To handle errors
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();

  // Construct URL dynamically based on the franchiseId
  const REGISTER_URL = `api/get-franchise?franchise_id=${franchiseId}`;

  useEffect(() => {
    const fetchData = async () => {
      const headers = {
        'Content-Type': 'application/json',
      };

      try {
        const response = await axiosPrivate.get(REGISTER_URL, {
          headers,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });
        setFranchise(response.data); // Store the fetched data into the franchise state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false);  // Set loading to false even if there is an error
      }
    };

    fetchData();
  }, [franchiseId]);  // Add franchiseId as a dependency to re-fetch data if franchiseId changes

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner component if you prefer
  }

  if (error) {
    return <div>{error}</div>; // Display error message if any
  }

  if (franchise) {
    return (
      <>
        {/* <Container> */}
        <section className="empbody">
          <div className="wrapperemp">
            <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">Franchise list</button>
            <h3>Franchise Details</h3>
            <br></br>
            <br></br>

            {auth.franchise_id == null && (
              <Row>
                <Col>
                  <p className="multip">
                    <span className="empspan">Fr. Creation Type :</span>{" "}
                    {franchise.parent_franchise_id == null
                      ? "Direct Franchise"
                      : "Under Another Fr."}
                  </p>
                </Col>
                <Col>
                  {franchise.parent_franchise_id !== null && (
                    <p className="multip">
                      <span className="empspan">Parent Fr. :</span>{" "}
                      {`${franchise.parent_business_type} - ${franchise.parent_franchise_name} (${franchise.parent_franchise_code})`}
                    </p>
                  )}
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <p className="multip"> <span className="empspan">Franchise Id :</span> {franchise.franchise_id}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Franchise Code :</span> {franchise.franchise_code}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">Franchise Name :</span> {franchise.franchise_name}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Business Type :</span> {franchise.business_type}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">State and District :</span> {franchise.state_name}, {franchise.district_name}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Place :</span> {franchise.place}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">City :</span> {franchise.city}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Land Phone :</span> {franchise.land_phone}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">Mobile :</span> {franchise.mobile}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Email :</span> {franchise.email}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">Address :</span> {franchise.address}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Contact Person :</span> {franchise.contact_person}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">Contract Date :</span> {franchise.contract_date}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Renewal Date :</span> {franchise.renewal_date}</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="multip"><span className="empspan">Expiry Date :</span> {franchise.expiry_date}</p>
              </Col>
              <Col>
                <p className="multip"><span className="empspan">Service Areas :</span> {franchise.service_areas}</p>
              </Col>
            </Row>

          </div>
        </section>
        <TopBar />
        {/* </Container> */}
      </>
    );
  }

  return <div>No Franchise data available.</div>;
};

export default GetFranchise;
